import Orders from '../../components/GameManagement/Orders';

const OrdersPage = () => {
	return <Orders />;
};

export default OrdersPage;
